import template from './calendarRangePicker.html';
import controller from './calendarRangePickerCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    pipelineSharedData: '<',
    activeRangeIndex: '<',
    customRanges: '<',
    onUpdate: '&',
    onRangeSelected: '&',
  },
};
